import React, { useEffect, useMemo, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useDispatch, useSelector } from "react-redux";
import {
  getInactiveClients,
  setInactiveClients,
  addEditClient,
  getClients,
} from "../../components/clients/clientsSlice";
import { Localize } from "../../app/lang/langs";

export default function InactiveClientsModal(props) {
  const dispatch = useDispatch();
  const visible = props.visible;
  const inactiveClients = useSelector(
    (state) => state.clients.inactiveClients || []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [activatingId, setActivatingId] = useState(null);

  useEffect(() => {
    if (visible) {
      dispatch(getInactiveClients());
    }
  }, [visible, dispatch]);

  const handleClose = () => {
    props.setVisible(false);
    dispatch(setInactiveClients([]));
    setGlobalFilter("");
    setActivatingId(null);
  };

  const activateClient = async (idClient) => {
    if (!idClient) return;
    try {
      setActivatingId(idClient);
      await dispatch(addEditClient({ id: idClient, active: 1 }));
      dispatch(getInactiveClients());
      dispatch(getClients());
    } finally {
      setActivatingId(null);
    }
  };
  const tableHeader = useMemo(
    () => (
      <div className="flex items-center gap-2 justify-between w-full">
        <span className="p-input-icon-left">
          <InputText
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="Recherche..."
          />
        </span>
      </div>
    ),
    [globalFilter]
  );
  const actionBody = (row) => (
    <Button
      label={activatingId === row.id ? "Réactivation..." : "Réactiver"}
      icon={activatingId === row.id ? "pi pi-spin pi-spinner" : "pi pi-check"}
      severity="success"
      size="small"
      onClick={() => activateClient(row.id)}
      disabled={!!activatingId}
    />
  );

  return (
    <Dialog
      header="Inactive Clients"
      visible={visible}
      onHide={handleClose}
      draggable={false}
      style={{ width: "60vw", maxWidth: 900 }}
      modal
    >
      {inactiveClients.length > 0 ? (
        <DataTable
          value={inactiveClients}
          header={tableHeader}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          removableSort
          scrollable
          sortMode="single"
          globalFilter={globalFilter}
          emptyMessage="No inactive clients found."
        >
          <Column field="id" header="ID" style={{ width: "8rem" }} sortable />
          <Column field="name" header={Localize("NAME")} sortable />
          <Column
            header="Actions"
            body={actionBody}
            style={{ width: "12rem", textAlign: "center" }}
          />
        </DataTable>
      ) : (
        <p className="m-0">No inactive clients found.</p>
      )}
    </Dialog>
  );
}
